<template>
	<div class="d-flex align-items-center mt-4 mb-4">
		<slot name="list-records-button">
			<a :href="viewRecordsUri()" class="btn btn-primary mr-2">
				<i class="fa fa-list"></i> {{ translate('RecordManager.' + recordType + '.list_' + recordType) }}
			</a>
		</slot>

		<slot name="add-record-button">
			<a :href="addRecordUri()" class="btn btn-primary mr-2">
				<i class="fa fa-plus-circle"></i> {{ translate('RecordManager.' + recordType + '.add_' + recordType) }}
			</a>
		</slot>

        <slot name="view-record-button">
        <a v-if="record" :href="viewRecordUri(record.id)" class="btn btn-primary mr-2">
            <i class="fa fa-eye"></i> Show {{ recordType | injectWhitespace | capitalizeWords }}
        </a>
        </slot>

		<slot name="edit-record-button">
			<a v-if="record" :href="editRecordUri(record.id)" class="btn btn-primary mr-2">
				<i class="fa fa-pencil"></i> Edit {{ recordType | injectWhitespace | capitalizeWords }}
			</a>
		</slot>

		<slot name="delete-record-button">
			<delete-record-button v-if="record" 
                                  :endpoint="deleteRecordUri(record.id)" 
                                  :redirect-url="viewRecordsUri()" 
                                  classes="btn btn-danger"
                                  :show-confirmation-dialog="true"
                                  :confirmation-dialog-title="translate('RecordManager.' + recordType + '.delete_' + recordType)"
                                  :confirmation-dialog-message="translate('RecordManager.' + recordType + '.delete_' + recordType + '_confirm')">
				<i class="fas fa-trash-alt"></i> {{ translate('RecordManager.' + recordType + '.delete_' + recordType) }}
			</delete-record-button>
		</slot>

        <slot name="custom-buttons"></slot>
	</div>
</template>

<script>
    export default {
        props: {
            recordType: { type: String, required: true },
            resourceUriPrefix: { type: String, required: true },
            record: { type: Object, required: false, default: undefined }
        },

        methods: {
            viewRecordUri(recordId) {
            	return this.resourceUriPrefix + '/' + recordId;
            },

            addRecordUri() {
				return this.resourceUriPrefix + '/create';
            },

            editRecordUri(recordId) {
            	return this.resourceUriPrefix + '/' + recordId + '/edit';
            },

            deleteRecordUri(recordId) {
            	return this.resourceUriPrefix + '/' + recordId;
            },

            viewRecordsUri() {
            	return this.resourceUriPrefix;
            }
        }
    }
</script>